import React, { useEffect, useState } from 'react';
import CakeCard from '../components/CakeCard';
import { Col, Row } from 'react-bootstrap';
import { get } from '../../../services/apiController';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import Breadcrumb from '../../../components/Breadcrumb';
import { Link } from 'react-router-dom';

const ProductDisplay = () => {
  const [productList, setProductList] = useState([]);
  const { categoryId, subCategoryId } = useParams();

  function fetchProducts() {
    try {
      get(`/cake/products/?subCategoryId=${subCategoryId}`)
        .then((response) => {
          setProductList(response.data.rows);
        })
        .catch((err) => {
          console.log('error', err);
        });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useEffect(() => {
    fetchProducts();
  }, [subCategoryId]);

  return (
    <Row className="px-2">
      <Breadcrumb
        navigation={[
          { link: '/cake/home', title: 'Categories' },
          { link: `/cake/sub-categories-display/${categoryId}`, title: 'Sub Categories' },
          { link: '#', title: 'Products' },
        ]}
      />
       <div>
      <Link to={"/cake/home"} className="text-decoration-none"><button className='btn app-btn-primary mb-3 me-5'>&larr; Back</button></Link>
      <Link to={"/cake/orders"} className="text-decoration-none"><button className='btn app-btn-primary mb-3 me-5' style={{float: "right"}}>Orders</button></Link>
      </div>
      {productList.length > 0
        ? productList?.map((item) => {
            return (
              <Col key={item.id} style={{ cursor: 'pointer' }} className="mb-3" lg={3} md={4} xs={6} sm={6} >
                <CakeCard
                  title={item?.name}
                  image={item?.images && item.images.length > 0 && `${process.env.REACT_APP_BASE_URL}/${item?.images[0]}`}
                  alt={item?.name}
                  link={`/cake/order-display/${categoryId}/${subCategoryId}/${item.id}`}
                />
              </Col>
            );
          })
        : 'No Products'}
    </Row>
  );
};

export default ProductDisplay;
